import {Injectable} from '@angular/core';
import $ from 'jquery';
import {forOwn} from 'lodash';

import {BehaviorSubject} from 'rxjs';
import {UntilDestroy} from '@ngneat/until-destroy';

import {ThrottleClass} from '../utils/throttle.class';
import {classColorsMap} from '../models/class-color-map.model';
import {lessVariables} from '../models/auto-generated.colors';
import {SessionStorageService} from './session-storage.service';

@UntilDestroy()
@Injectable({
    providedIn: 'root'
})
export class GeneralService {
    static DEBUG_MODE_SESSION_KEY = 'debugMode';

    static statusColors = lessVariables;

    static statusToColorMap = {
        ERROR: GeneralService.statusColors.redStatus,
        CRITICAL: GeneralService.statusColors.redStatus,
        POOR: GeneralService.statusColors.redStatus,
        MINOR: GeneralService.statusColors.yellowStatus,
        FAIR: GeneralService.statusColors.yellowStatus,
        WARNING: GeneralService.statusColors.orangeStatus,
        MAJOR: GeneralService.statusColors.orangeStatus,
        OK: GeneralService.statusColors.greenStatus,
        GOOD: GeneralService.statusColors.greenStatus,
        PRIMARY: GeneralService.statusColors.blueStatus,
        UNKNOWN: GeneralService.statusColors.grayStatus,
        UNDEFINED: GeneralService.statusColors.grayStatus,
        UNMONITORED: GeneralService.statusColors.grayStatus,
    };

    static classColors = classColorsMap;
    static testMode;
    PDFMode;
    loginErrorMessage = '';
    doInitValidationsForAcForm = true;
    isViewMode = false;
    MFAInProgress = false;

    enforcePrivacyMode;
    resize$;
    systemInitialized = null;
    customLocalize;
    rtl = false;
    systemLanguage$;
    disableFullScreenAcChart = false;
    loading: any = {
        webSocket: {
            progress: 30
        },
        entities: {
            progress: 40
        },
        workspace: {
            progress: 50
        },
        metadata: {
            progress: 60
        },
        metrics: {
            progress: 70
        },
        infoColumns: {
            progress: 80
        },
        filteredEntities: {
            progress: 90
        },
    };
    private isDebugMode = SessionStorageService.getData(GeneralService.DEBUG_MODE_SESSION_KEY) || false;
    private _systemLanguage = new BehaviorSubject<string>('en');

    constructor() {
        this.systemLanguage$ = this._systemLanguage.asObservable();
        // REMOVE ON ng2
        window.addEventListener('focus', () => {
            GeneralService.dispatchResizeEvent();
        });
    }

    get debugMode() {
        return !!this.isDebugMode;
    }

    set debugMode(state: boolean) {
        this.isDebugMode = state;
        SessionStorageService.setData(GeneralService.DEBUG_MODE_SESSION_KEY, this.isDebugMode);
    }

    static handleEvent = (eventName) => {
        let event;
        if (typeof (Event) === 'function') {
            event = new Event(eventName);
        } else {
            event = document.createEvent('Event');
            event.initEvent(eventName, true, true);
        }

        return event;
    };

    static dispatchResizeEvent = () => {
        if (document.visibilityState === 'hidden') {
            return;
        }
        GeneralService.resize$.tick();
    };

    static updateGlobalConfig = (context, forRootConfig) => {
        if (!forRootConfig) {
            return;
        }
        Object.getOwnPropertyNames(forRootConfig)
            .filter((configKey) => {
                return forRootConfig[configKey] !== undefined;
            })
            .forEach((configKey) => {
                context[configKey] = forRootConfig[configKey];
            });
    };

    private static dispatchResize = () => {
        const dispatch = () => {
            const event = GeneralService.handleEvent('resize');
            window.dispatchEvent(event);
        };
        setTimeout(dispatch, 0);
    };

    static resize$ = new ThrottleClass({
        callback: GeneralService.dispatchResize,
        maxRecurrentTime: 400
    });

    resetLoading() {
        forOwn(this.loading, (step) => {
            step.finished = false;
        });
    }

    finishedLoading(step) {
        this.loading[step].finished = true;
        this.loading = {...this.loading};
    }

    getProgress() {
        const currentStepName = Object.getOwnPropertyNames(this.loading).find((step) => {
            return !this.loading[step].finished;
        });
        return this.loading[currentStepName] ? this.loading[currentStepName]?.progress + '%' : '';
    }

    setLocalizeErrorsObject = (localize) => {
        this.customLocalize = localize;
    };

    setSystemLanguage = (lang) => { // VOCA ARE USING THIS !!!!!!!!!!!!
        this._systemLanguage.next(lang);
    };

    // createObjectByPath(myObj, 'sub1.sub2.propA', 1);
    // createObjectByPath(myObj, ['sub1', 'sub2', 'propA'], 1);

    generateIdForText = (text, postFix = '') => {
        return text.toLowerCase().replace(/\./g,'-').replace(/ /g, '-') + postFix;
    };

    generateId = (text, postFix = '') => {
        return text.replace(/\./g,'-') + postFix;
    };

    convertObjectToArray = (object) => {
        const resultArray = [];

        forOwn(object, (prop, key) => {
            resultArray.push(object[key]);
        });

        return resultArray;
    };

    cleanEmptyValues = (obj, cleanEmptyStringAndUndefined = false) => {
        forOwn(obj, (value, key) => {
            if (obj[key] && typeof obj[key] === 'object') {
                this.cleanEmptyValues(obj[key], cleanEmptyStringAndUndefined);
            } else if (value === null) {
                delete obj[key];
            } else if (cleanEmptyStringAndUndefined && (value === undefined || value === '')) {
                delete obj[key];
            }
        });
    };

    // will create path if not exist or change it if exist
    createObjectByPath = (obj, arr, val) => {
        if (typeof arr == 'string') {
            arr = arr.split('.');
        }

        obj[arr[0]] = obj[arr[0]] || {};

        const tmpObj = obj[arr[0]];

        if (arr.length > 1) {
            arr.shift();
            this.createObjectByPath(tmpObj, arr, val);
        } else {
            obj[arr[0]] = val;
        }

        return obj;
    };

    HTMLDecode = (text) => $('<div>').text(text).html().ReplaceAll('"', '&quot;');

    noCompare = () => 0;
}

